/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} SpreadInputs */

const en_spread = /** @type {(inputs: SpreadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spread`)
};

const es_spread = /** @type {(inputs: SpreadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pliego`)
};

const fr_spread = /** @type {(inputs: SpreadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Double page`)
};

const de_spread = /** @type {(inputs: SpreadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Doppelseite`)
};

const ja_spread = /** @type {(inputs: SpreadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`見開き`)
};

const zh_spread = /** @type {(inputs: SpreadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`跨页`)
};

const ar_spread = /** @type {(inputs: SpreadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`صفحة مزدوجة`)
};

const id_spread = /** @type {(inputs: SpreadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hamparan`)
};

const it_spread = /** @type {(inputs: SpreadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pagina doppia`)
};

const ru_spread = /** @type {(inputs: SpreadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Разворот`)
};

const pt_spread = /** @type {(inputs: SpreadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Página dupla`)
};

const ko_spread = /** @type {(inputs: SpreadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`스프레드`)
};

/**
* | output |
* | --- |
* | "Spread" |
*
* @param {SpreadInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const spread = /** @type {((inputs?: SpreadInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<SpreadInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_spread(inputs)
	if (locale === "es") return es_spread(inputs)
	if (locale === "fr") return fr_spread(inputs)
	if (locale === "de") return de_spread(inputs)
	if (locale === "ja") return ja_spread(inputs)
	if (locale === "zh") return zh_spread(inputs)
	if (locale === "ar") return ar_spread(inputs)
	if (locale === "id") return id_spread(inputs)
	if (locale === "it") return it_spread(inputs)
	if (locale === "ru") return ru_spread(inputs)
	if (locale === "pt") return pt_spread(inputs)
	return ko_spread(inputs)
});